import React, { useState } from "react";
import "./Slider.css";
import { BASE_URL } from "../Base_url/Base_Url"; // BASE_URL = "https://apicallforcab.maharajacabs.in"

const BookNow = () => {
    const [formData, setFormData] = useState({
        ContectUs_name: "",
        ContectUs_email: "",
        ContectUs_cono: "",
        // ContectUs_subject: "",
        ContectUs_message: "",
        ContectUs_Travel_Date: "",
    });

    // input change handle
    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value });
    };

    // form submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${BASE_URL}/contactsubmit/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),

            });

            if (response.ok) {
                alert("Booking submitted successfully!");
                setFormData({
                    ContectUs_name: "",
                    ContectUs_email: "",
                    ContectUs_cono: "",
                    // ContectUs_subject: "",
                    ContectUs_message: "",
                    ContectUs_Travel_Date: "",
                });
            } else {
                const errorData = await response.json();
                console.error("API Error:", errorData);
                alert("Failed to submit booking. Please try again!");
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            alert("Something went wrong!");
            console.log('formData', formData);
        }
    };

    return (
        <div className="booking-form-wrapper">
            <div className="booking-form">
                <h3>Book Your Ride</h3>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="ContectUs_name">First Name </label>
                        <input
                            type="text"
                            id="ContectUs_name"
                            className="form-control"
                            placeholder="Enter your name"
                            value={formData.ContectUs_name}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="ContectUs_email">Email Address </label>
                        <input
                            type="email"
                            id="ContectUs_email"
                            className="form-control"
                            placeholder="Enter your email"
                            value={formData.ContectUs_email}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="ContectUs_cono">Email Address </label>
                        <input
                            type="text"
                            id="ContectUs_cono"
                            className="form-control"
                            placeholder="Enter your contact number"
                            value={formData.ContectUs_cono}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {/* <div className="form-group">
                        <label htmlFor="ContectUs_subject">ContectUs Subject</label>
                        <input
                            type="text"
                            id="ContectUs_subject"
                            className="form-control"
                            placeholder="Enter subject"
                            value={formData.ContectUs_subject}
                            onChange={handleChange}
                            required
                        />
                    </div> */}

                    <div className="form-group">
                        <label htmlFor="ContectUs_message"> Message</label>
                        <textarea
                            id="ContectUs_message"
                            className="form-control"
                            placeholder="Enter message"
                            value={formData.ContectUs_message}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="ContectUs_Travel_Date"> Travel Date</label>
                        <input
                            type="date"
                            id="ContectUs_Travel_Date"
                            className="form-control"
                            value={formData.ContectUs_Travel_Date}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <button type="submit" className="btn btn-primary w-100">
                        Book Now
                    </button>
                </form>
            </div>
        </div>
    );
};

export default BookNow;
